// extracted by mini-css-extract-plugin
module.exports = {"video":"Highlights-module--video--1NNFi","videoParent":"Highlights-module--videoParent--NAHA5","fullWidth":"Highlights-module--fullWidth--32Bbg"};